// x-scroll-motion.js

/*
Works alongside css of same name to create motion in frontpage rows
IMPORTANTt: Refer to css for notes on use

- Detects when rows with class "scroll-motion" enter the screen, and adds a class to them
- A threshold value is set for when the element is to be considered on screen
- Can also use transition-delay in css to adjust when motion starts
- Lazy-loading images are handled so that they load in time
*/

export default function xScrollMotion() {

  const movingElementsAll = document.querySelectorAll(".scroll-motion");
  if (movingElementsAll.length) {
    movingElementsAll.forEach(movingElement => {

      const movingImages = movingElement.querySelectorAll("img");
      const elementHeight = movingElement.getBoundingClientRect().height;
      let thresholdValue = 0.2;

      // Reduce threshold if element is taller than window
      if (elementHeight > window.innerHeight) {
        thresholdValue = 0;
      }

      // Observe when element enters viewport
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Add class to use with css
            entry.target.classList.add("entered-view");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: thresholdValue
      });
      observer.observe(movingElement);



      // Handle image lazy-loading.
      // When first image in a row is loaded, load all images in same row (remove lazy-load attribute).
      // Otherwise, images will not load until scrolling sideways and there will be empty spaces.
      if (movingImages.length) {
        let hasLoaded = false;

        movingImages.forEach(image => {
          image.addEventListener("load", (event) => {
            if (!hasLoaded) {
              const loadedImage = event.target;
              hasLoaded = true;

              // Remove lazy-loading from sibling images
              const siblings = image.closest(".vrtx-frontpage-box").querySelectorAll("img");
              siblings.forEach(sibling => {
                sibling.removeAttribute("loading");
              });
            }
          });
        });
      }
    });
  }
}